import _Object$keys from "@babel/runtime-corejs3/core-js/object/keys";
import _Object$getOwnPropertySymbols from "@babel/runtime-corejs3/core-js/object/get-own-property-symbols";
import _filterInstanceProperty from "@babel/runtime-corejs3/core-js/instance/filter";
import _Object$getOwnPropertyDescriptor from "@babel/runtime-corejs3/core-js/object/get-own-property-descriptor";
import _Object$getOwnPropertyDescriptors from "@babel/runtime-corejs3/core-js/object/get-own-property-descriptors";
import _Object$defineProperties from "@babel/runtime-corejs3/core-js/object/define-properties";
import _Object$defineProperty from "@babel/runtime-corejs3/core-js/object/define-property";
import _defineProperty from "@babel/runtime-corejs3/helpers/defineProperty";
import _Math$trunc from "@babel/runtime-corejs3/core-js/math/trunc";
import _JSON$stringify from "@babel/runtime-corejs3/core-js/json/stringify";
function ownKeys(e, r) { var t = _Object$keys(e); if (_Object$getOwnPropertySymbols) { var o = _Object$getOwnPropertySymbols(e); r && (o = _filterInstanceProperty(o).call(o, function (r) { return _Object$getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : _Object$getOwnPropertyDescriptors ? _Object$defineProperties(e, _Object$getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { _Object$defineProperty(e, r, _Object$getOwnPropertyDescriptor(t, r)); }); } return e; }
import { computed, defineComponent, reactive, onMounted, onUnmounted, ref, nextTick } from "@vue/composition-api";
import * as FieldComponents from "@Shared/components/sections/index";
import { formatMoneyValueLong } from "@Shared/@Utils/helpers/money";
import MortgageAmschedule from "./mortgage-amschedule.vue";
import MortgageCalculatorsToolbar from "./mortgage-calculators-toolbar.vue";
import ReportTabLayout from "@Broker/@Modules/clients/reports/reports-containers/report-tab-layout.vue";
import { MORTGAGE_FREQUENCY } from "@Shared/@Types/application/application-enums";
import { APPLICATION_FIELD_OPTIONS } from "@Shared/@Utils/application-defaults-utils/global-field-options";
import { showToast } from "@Shared/@Utils/constants";
import { capitalize } from "@Shared/@Utils/helpers/text";
import i18n from "@Shared/i18n";
import { CALCULATOR_FORMS } from "@Broker/@Types/financial-tools/types";
import { defaultPrintAction } from "../store/financial-tools-actions";
const componentName = "MortgageIsolatorContainer";
export default defineComponent({
  name: componentName,
  components: _objectSpread(_objectSpread({}, FieldComponents), {}, {
    MortgageAmschedule,
    MortgageCalculatorsToolbar,
    ReportTabLayout
  }),
  setup() {
    function yearlyPaymentsMap(freqs) {
      switch (freqs) {
        default:
          return 12;
        case MORTGAGE_FREQUENCY.SEMI_MONTHLY:
          return 24;
        case MORTGAGE_FREQUENCY.BIWEEKLY:
        case MORTGAGE_FREQUENCY.ACCELERATED_BIWEEKLY:
          return 26;
        case MORTGAGE_FREQUENCY.WEEKLY:
        case MORTGAGE_FREQUENCY.ACCELERATED_WEEKLY:
          return 52;
      }
    }
    const COMPOUND = 2;
    const AMORTMAX = 35 * 12;
    let wrongCalcResult = false;
    const thisComponentCookieString = localStorage.getItem(componentName);
    const thisComponentCookieData = thisComponentCookieString ? JSON.parse(thisComponentCookieString) : {};
    const inoudata = reactive({
      showAMsched: false,
      doHideAMsched: () => {
        inoudata.showAMsched = false;
      },
      frequency: thisComponentCookieData.frequency || MORTGAGE_FREQUENCY.MONTHLY,
      amortizPeriodMths: thisComponentCookieData.amortizPeriodMths || 0,
      mortgageAmount: thisComponentCookieData.mortgageAmount || 0,
      interestRate: thisComponentCookieData.interestRate || 0,
      PandI: thisComponentCookieData.PandI || 0,
      revamortizPeriodMths: thisComponentCookieData.revamortizPeriodMths || 0,
      intFact: 0,
      baseRevAm: 0,
      timeKind: 0,
      numPay2: 0,
      whatyear: 0
    });
    const {
      mortgageFrequencyOptions
    } = APPLICATION_FIELD_OPTIONS();
    const yearlyPayments = computed(() => yearlyPaymentsMap(inoudata.frequency));
    function formatMoney(val) {
      return formatMoneyValueLong(val);
    }
    function formatRate(val) {
      return val && val > 0 ? this.$options.filters.parsePercentageDecimal(val) : "-";
    }
    function roundPen(val, decs) {
      const fact = 10 ** decs;
      return val > 0 ? Math.round(val * fact) / fact : 0;
    }
    function showMessage(msga, fldName, msgb) {
      const msg = wrongCalcResult ? msga.toString() + fldName + i18n.t("financial-tools.message_wrong_result2") : fldName + ": " + msgb;
      wrongCalcResult = false;
      showToast("error", msg);
    }
    function validAmortizPeriodMths() {
      const val = Number(inoudata.amortizPeriodMths);
      const valid = val >= 1 && val <= AMORTMAX;
      if (valid) return true;
      showMessage(i18n.t("financial-tools.message_wrong_result_amortization_period1"), i18n.t("financial-tools.amortization_period"), i18n.t("financial-tools.message_missing_question_3"));
      $("[name='amortizPeriodMths']").trigger("focus");
      return false;
    }
    function validMortgageAmount() {
      const val = Number(inoudata.mortgageAmount);
      const valid = val >= 10000 && val <= 100000000;
      if (valid) return true;
      showMessage(i18n.t("financial-tools.message_wrong_result_mortgage_amount1"), i18n.t("financial-tools.mortgage_amount"), i18n.t("financial-tools.message_missing_question_1"));
      $("[name='mortgageAmount']").trigger("focus");
      return false;
    }
    function validInterestRate() {
      const val = Number(inoudata.interestRate);
      const valid = val > 0 && val <= 100.0;
      if (valid) return true;
      showMessage(i18n.t("financial-tools.message_wrong_result_interest_rate1"), i18n.t("financial-tools.interest_rate"), i18n.t("financial-tools.message_missing_question_2"));
      $("[name='interestRate']").trigger("focus");
      return false;
    }
    function validPandI() {
      const val = Number(inoudata.PandI);
      const valid = val > 0 && val <= 100000000;
      if (valid) return true;
      showToast("error", i18n.t("financial-tools.mortgagePayment") + ": " + i18n.t("financial-tools.message_missing_question1M"));
      $("[name='PAndI']").trigger("focus");
      return false;
    }
    function compute(n) {
      if (n != 2) {
        if (!validAmortizPeriodMths()) return false;
      }
      if (n != 3) {
        if (!validMortgageAmount()) return false;
      }
      if (n != 4) {
        if (!validInterestRate()) return false;
      }
      if (n != 5) {
        if (!validPandI()) return false;
      }
      return true;
    }
    function frequencyFactors() {
      const paymentFrequency = inoudata.frequency;
      let yearlyPays;
      let frequencyToUse;
      let monthFactor;
      const daysInYear = 365.25;
      if (paymentFrequency == MORTGAGE_FREQUENCY.MONTHLY) {
        yearlyPays = 12;
        frequencyToUse = yearlyPays;
        monthFactor = 1;
      } else if (paymentFrequency == MORTGAGE_FREQUENCY.SEMI_MONTHLY) {
        yearlyPays = 24;
        frequencyToUse = yearlyPays;
        monthFactor = 2;
      } else if (paymentFrequency == MORTGAGE_FREQUENCY.ACCELERATED_BIWEEKLY) {
        yearlyPays = 26;
        frequencyToUse = 12;
        monthFactor = 2.0;
      } else if (paymentFrequency == MORTGAGE_FREQUENCY.ACCELERATED_WEEKLY) {
        yearlyPays = 52;
        frequencyToUse = 12;
        monthFactor = 4.0;
      } else if (paymentFrequency == MORTGAGE_FREQUENCY.BIWEEKLY) {
        yearlyPays = 26;
        frequencyToUse = yearlyPays;
        monthFactor = daysInYear / 14 / 12;
      } else if (paymentFrequency == MORTGAGE_FREQUENCY.WEEKLY) {
        yearlyPays = 52;
        frequencyToUse = yearlyPays;
        monthFactor = daysInYear / 7 / 12;
      } else {
        yearlyPays = 12;
        frequencyToUse = yearlyPays;
        monthFactor = 1;
      }
      return {
        yearlyPays,
        frequencyToUse,
        monthFactor
      };
    }
    function findAmort(MORTGAGE, RATE, compounda, PAYMENT, paysPerYr) {
      const compound = compounda / paysPerYr;
      const yrRate = RATE / compounda;
      const rdefine = Math.pow(1.0 + yrRate, compound) - 1.0;
      wrongCalcResult = true;
      let amorTry;
      let bega = 0;
      let enda = AMORTMAX;
      for (amorTry = 25 * 12;; amorTry = (bega + enda) / 2) {
        const monTime = amorTry;
        const comfact = Math.pow(1.0 + rdefine, monTime);
        const newpay = MORTGAGE * rdefine * comfact / (comfact - 1.0);
        const diff = newpay - PAYMENT;
        if (Math.abs(diff) < 0.005) break;
        if (amorTry <= 1 || AMORTMAX - amorTry < 0.00001) return 0;
        if (diff <= 0) enda = amorTry;else bega = amorTry;
      }
      return amorTry;
    }
    function calcAmortizPeriod() {
      const mortgageAmount = Number(inoudata.mortgageAmount);
      const intrate = Number(inoudata.interestRate) / 100;
      const payment = Number(inoudata.PandI);
      const {
        monthFactor
      } = frequencyFactors();
      const returnpay = payment * monthFactor;
      const paysPerYr = 12;
      const solvecom = findAmort(mortgageAmount, intrate, COMPOUND, returnpay, paysPerYr);
      inoudata.amortizPeriodMths = Math.round(solvecom);
    }
    function calcMtgAmt() {
      const amortizPeriodMths = Number(inoudata.amortizPeriodMths);
      const intrate = Number(inoudata.interestRate) / 100;
      const payment = Number(inoudata.PandI);
      const {
        yearlyPays,
        monthFactor
      } = frequencyFactors();
      const returnpay = payment * monthFactor;
      wrongCalcResult = true;
      const yrRate = intrate / 2;
      let mortgageAmount;
      if (yearlyPays == 24) {
        const compound2 = COMPOUND / 24;
        const monTime2 = amortizPeriodMths * 2;
        const rdefine2 = Math.pow(1.0 + yrRate, compound2) - 1.0;
        const comfact2 = Math.pow(1.0 + rdefine2, monTime2);
        mortgageAmount = payment * (comfact2 - 1) / (rdefine2 * comfact2);
      } else {
        const paysPerYr = 12;
        const compound = COMPOUND / paysPerYr;
        const monTime = amortizPeriodMths;
        const rdefine = Math.pow(1.0 + yrRate, compound) - 1.0;
        const comfact = Math.pow(1.0 + rdefine, monTime);
        mortgageAmount = returnpay * (comfact - 1) / (rdefine * comfact);
      }
      inoudata.mortgageAmount = roundPen(mortgageAmount, 2);
    }
    function findRate(PAYMENT, paysPerYr, monTime) {
      const mortgageAmount = Number(inoudata.mortgageAmount);
      const compound = COMPOUND / paysPerYr;
      wrongCalcResult = true;
      let rateTry;
      let bega = 0;
      let enda = 100;
      for (rateTry = 12;; rateTry = (bega + enda) / 2) {
        const RATE = rateTry / 100;
        const yrRate = RATE / COMPOUND;
        const rdefine = Math.pow(1.0 + yrRate, compound) - 1.0;
        const comfact = Math.pow(1.0 + rdefine, monTime);
        const newpay = mortgageAmount * rdefine * comfact / (comfact - 1.0);
        const diff = newpay - PAYMENT;
        if (Math.abs(diff) < 0.005) break;
        if (rateTry <= 0.001 || 100 - rateTry < 0.00001) return 0;
        if (diff > 0) enda = rateTry;else bega = rateTry;
      }
      return rateTry;
    }
    function calcInterestRate() {
      const amortizPeriodMths = Number(inoudata.amortizPeriodMths);
      const payment = Number(inoudata.PandI);
      const {
        yearlyPays,
        monthFactor
      } = frequencyFactors();
      const returnpay = payment * monthFactor;
      let interestRate;
      if (yearlyPays == 24) {
        const paysPerYr = 24;
        const monTime = amortizPeriodMths * 2;
        interestRate = findRate(payment, paysPerYr, monTime);
      } else {
        const paysPerYr = 12;
        const monTime = amortizPeriodMths;
        interestRate = findRate(returnpay, paysPerYr, monTime);
      }
      inoudata.interestRate = roundPen(interestRate, 3);
    }
    function calculatePayment() {
      const amortizPeriodMths = Number(inoudata.amortizPeriodMths);
      const mortgageAmount = Number(inoudata.mortgageAmount);
      const intrate = Number(inoudata.interestRate) / 100;
      const yrRate = intrate / COMPOUND;
      let returnpay;
      const {
        yearlyPays,
        frequencyToUse,
        monthFactor
      } = frequencyFactors();
      if (frequencyToUse == 12) {
        const compound = COMPOUND / frequencyToUse;
        const monTime = amortizPeriodMths;
        const rdefine = Math.pow(1.0 + yrRate, compound) - 1.0;
        const comfact = Math.pow(1.0 + rdefine, monTime);
        const payment = mortgageAmount * rdefine * comfact / (comfact - 1.0);
        returnpay = payment / monthFactor;
      } else {
        const compound2 = COMPOUND / yearlyPays;
        const monTime2 = amortizPeriodMths * yearlyPays / 12;
        const rdefine2 = Math.pow(1.0 + yrRate, compound2) - 1.0;
        const comfact2 = Math.pow(1.0 + rdefine2, monTime2);
        const payment = mortgageAmount * rdefine2 * comfact2 / (comfact2 - 1.0);
        returnpay = payment;
      }
      inoudata.PandI = roundPen(returnpay, 2);
    }
    function calcRevPay(compounda) {
      const amortizPeriodMths = Number(inoudata.amortizPeriodMths);
      const mortgageAmount = Number(inoudata.mortgageAmount);
      const intrate = Number(inoudata.interestRate);
      const intratep = intrate / 100;
      const yrRate = intratep / compounda;
      let returnpay;
      const {
        yearlyPays,
        monthFactor
      } = frequencyFactors();
      if (yearlyPays == 24) {
        const compound2 = compounda / yearlyPays;
        const monTime2 = _Math$trunc(amortizPeriodMths / 12) * yearlyPays + amortizPeriodMths % 12 * 2;
        const rdefine2 = Math.pow(1.0 + yrRate, compound2) - 1.0;
        const comfact2 = Math.pow(1.0 + rdefine2, monTime2);
        const payment = mortgageAmount * rdefine2 * comfact2 / (comfact2 - 1.0);
        returnpay = payment;
      } else {
        const paysPerYr = 12;
        const compound = compounda / paysPerYr;
        const monTime = amortizPeriodMths;
        const rdefine = Math.pow(1.0 + yrRate, compound) - 1.0;
        const comfact = Math.pow(1.0 + rdefine, monTime);
        const payment = mortgageAmount * rdefine * comfact / (comfact - 1.0);
        returnpay = payment / _Math$trunc(monthFactor);
      }
      return returnpay;
    }
    function compRevAmort() {
      const FREQ = yearlyPayments.value;
      if (FREQ == 12 || FREQ == 24) {
        inoudata.revamortizPeriodMths = Number(inoudata.amortizPeriodMths);
        return;
      }
      const mortgageAmount = Number(inoudata.mortgageAmount);
      const intrate = Number(inoudata.interestRate);
      const intratep = intrate / 100;
      const intFact = Math.pow(1.0 + intratep / 2, 2 / FREQ) - 1;
      const payment = calcRevPay(COMPOUND);
      let principalBal = mortgageAmount;
      let aYear = false;
      let annualCount = 0;
      let checkLump;
      let payAdd;
      for (payAdd = 1; principalBal > 0; payAdd++) {
        checkLump = 0;
        if ((payAdd - 1) / Math.floor(FREQ) == annualCount) {
          aYear = true;
        }
        const interestPayment = roundPen(principalBal * intFact, 2);
        const principalPayment = roundPen(payment - interestPayment, 2);
        let checkBal = principalPayment > principalBal ? principalBal : principalPayment;
        principalBal = roundPen(principalBal - checkBal, 2);
        if (aYear && 0 >= annualCount) {
          const lumpAmt = 0;
          checkLump = lumpAmt > principalBal ? principalBal : lumpAmt;
          principalBal = roundPen(principalBal - checkLump, 2);
        }
        if (principalBal < (interestPayment + principalPayment) / 2) {
          checkBal = checkBal + principalBal;
          principalBal = 0;
        }
        if (aYear) {
          annualCount = annualCount + 1;
          aYear = false;
        }
      }
      const totalYears = (payAdd - 1) / FREQ;
      inoudata.revamortizPeriodMths = Math.round(totalYears * 12);
    }
    function controlVars(n) {
      inoudata.showAMsched = false;
      wrongCalcResult = false;
      if (!compute(n)) return false;
      if (n == 2) {
        calcAmortizPeriod();
      } else if (n == 3) {
        calcMtgAmt();
      } else if (n == 4) {
        calcInterestRate();
      } else if (n == 5) {
        calculatePayment();
      }
      const ret = compute(9);
      if (ret) compRevAmort();
      return ret;
    }
    function computeAm(whatyear) {
      if (!controlVars(5)) {
        return false;
      }
      const numPay2 = yearlyPayments.value;
      const amortizPeriodMths = Number(inoudata.amortizPeriodMths);
      const intrate = Number(inoudata.interestRate);
      const intratep = intrate / 100;
      const intFact = Math.pow(1.0 + intratep / 2, 2 / numPay2) - 1;
      const baseRevAm = amortizPeriodMths / 12 * numPay2;
      let timeKind;
      if (whatyear == -1) {
        timeKind = 0;
      } else {
        whatyear = 0;
        timeKind = 1;
      }
      inoudata.intFact = intFact;
      inoudata.baseRevAm = baseRevAm;
      inoudata.numPay2 = numPay2;
      inoudata.timeKind = timeKind;
      inoudata.whatyear = whatyear;
      return true;
    }
    const isLoading = ref(false);
    const loadingSucceeded = ref(true);
    function amortLink(whatyear) {
      isLoading.value = true;
      loadingSucceeded.value = true;
      inoudata.showAMsched = computeAm(whatyear);
      loadingSucceeded.value = false;
      isLoading.value = false;
    }
    const handleClearSelection = () => {
      inoudata.showAMsched = false;
      inoudata.frequency = MORTGAGE_FREQUENCY.MONTHLY;
      inoudata.amortizPeriodMths = 25 * 12;
      inoudata.revamortizPeriodMths = 0;
      inoudata.mortgageAmount = 0;
      inoudata.interestRate = 0;
      inoudata.PandI = 0;
    };
    const runReport = async () => {
      isLoading.value = true;
      loadingSucceeded.value = true;
      amortLink(-1);
      await nextTick();
      const data = {
        paymentFrequency: inoudata.frequency,
        mortgageAmount: inoudata.mortgageAmount,
        interestRate: inoudata.interestRate,
        amortizationPeriod: inoudata.amortizPeriodMths,
        PandI: inoudata.PandI,
        revisedAmortizationPeriod: inoudata.revamortizPeriodMths,
        amSchedule: amScheduleData.value
      };
      try {
        await defaultPrintAction({
          type: CALCULATOR_FORMS.MORTGAGE_ISOLATOR,
          data
        });
      } catch (e) {
        loadingSucceeded.value = false;
        console.error(e);
      }
      isLoading.value = false;
    };
    const amScheduleData = ref(null);
    const generatedAmSchedule = data => {
      amScheduleData.value = data;
    };
    onMounted(() => {
      $("[name='frequency']").trigger("focus");
    });
    onUnmounted(() => {
      localStorage.setItem(componentName, _JSON$stringify(inoudata));
    });
    return {
      inoudata,
      mortgageFrequencyOptions,
      formatMoney,
      formatRate,
      capitalize,
      controlVars,
      amortLink,
      handleClearSelection,
      runReport,
      isLoading,
      loadingSucceeded,
      generatedAmSchedule
    };
  }
});